import { cn } from "$/lib/utils/functions/misc.functions";
import { BaseInput } from "../../atoms";
import type { TextInputProps } from "./TextInput.types";
import { forwardRef } from "react";
import { WarningIcon } from "$/lib/icons/WarningIcon";
import { customColors } from "tailwind.config";
import Flexbox from "../../common/Flexbox";

const TextInput = forwardRef<HTMLInputElement, TextInputProps>(
  (
    {
      className,
      Icon,
      EndIcon,
      containerClassName,
      isError,
      errorMessage = "This field is required",
      hintMessage,
      label,
      labelClassName,
      ...props
    },
    ref,
  ) => {
    return (
      <div className={cn("relative", containerClassName)}>
        <Flexbox>
          {label && (
            <p
              className={cn(
                "mb-1 ml-1 text-sm font-normal text-tertiary-600",
                labelClassName,
              )}
            >
              {label}
            </p>
          )}

          <BaseInput
            className={cn(className)}
            type="text"
            isError={isError}
            errorMessage={errorMessage}
            Icon={Icon}
            EndIcon={EndIcon}
            {...props}
            ref={ref}
          />
        </Flexbox>

        {hintMessage && (
          <p className="mt-1 flex items-center gap-2 text-xs text-tertiary-500">
            {hintMessage}
          </p>
        )}

        {isError && errorMessage && (
          <p className="mt-1 flex items-center gap-1 text-xs text-error">
            <WarningIcon
              color={customColors.error.DEFAULT}
              className="size-4"
            />
            {errorMessage}
          </p>
        )}
      </div>
    );
  },
);

TextInput.displayName = "TextInput";

export default TextInput;
